import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

import { computed } from 'vue'

interface Item {
  title: string
  value: number | string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DsMultipleSelect',
  props: {
    modelValue: {},
    items: {},
    itemTitle: {},
    itemValue: {},
    loading: { type: Boolean },
    borderPrimary: { type: Boolean },
    error: { type: Boolean },
    errorMessage: {}
  },
  emits: ["update:modelValue", "update:search"],
  setup(__props: any, { emit }) {

const props = __props;





const onUpdateModelValue = (value: Item[]): void => {
  emit('update:modelValue', value)
}

const itemTitle = props.itemTitle || 'title'
const itemValue = props.itemValue || 'value'
const borderPrimary = props.borderPrimary ?? true

const allItemsSelected = computed(() => {
  if (!props.modelValue || props.items.length === 0) return false
  return props.modelValue.length === props.items.length
})

const someItemsSelected = computed(() => {
  if (!props.modelValue) return false
  return props.modelValue.length > 0 && !allItemsSelected.value
})

const toggleSelectAll = () => {
  if (allItemsSelected.value) {
    emit('update:modelValue', [])
  } else {
    emit('update:modelValue', [...props.items])
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(_component_v_autocomplete, {
    "model-value": _ctx.modelValue,
    items: _ctx.items,
    "item-title": _unref(itemTitle),
    "item-value": _unref(itemValue),
    "return-object": "",
    loading: _ctx.loading,
    chips: "",
    multiple: "",
    clearable: "",
    class: _normalizeClass(["w-full my-autocomplete", {
      'custom-border-primary': _unref(borderPrimary) || (_ctx.modelValue && _ctx.modelValue.length > 0)
    }]),
    color: "primary20",
    variant: "outlined",
    density: "comfortable",
    error: _ctx.error,
    "error-messages": _ctx.errorMessage,
    "hide-details": "auto",
    "onUpdate:modelValue": onUpdateModelValue,
    "onUpdate:search": _cache[0] || (_cache[0] = (val) => emit('update:search', val))
  }, {
    "prepend-item": _withCtx(() => [
      _createVNode(_component_v_list_item, {
        title: "Selecionar Todos",
        onClick: toggleSelectAll
      }, {
        prepend: _withCtx(() => [
          _createVNode(_component_v_checkbox_btn, {
            "model-value": allItemsSelected.value,
            indeterminate: someItemsSelected.value,
            "hide-details": ""
          }, null, 8, ["model-value", "indeterminate"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider, { class: "mt-2" })
    ]),
    chip: _withCtx(({ item, index, props }) => [
      (allItemsSelected.value && index === 0)
        ? (_openBlock(), _createBlock(_component_v_chip, _mergeProps({ key: 0 }, props, { class: "bg-[#E2E2E9] text-black text-sm rounded-md px-1 py-1 border border-gray-500" }), {
            default: _withCtx(() => [
              _createTextVNode(" Todos ")
            ]),
            _: 2
          }, 1040))
        : (!allItemsSelected.value)
          ? (_openBlock(), _createBlock(_component_v_tooltip, {
              key: 1,
              text: item.raw[_unref(itemTitle)],
              location: "top"
            }, {
              activator: _withCtx(({ props: tooltipProps }) => [
                _createVNode(_component_v_chip, _mergeProps({ ...props, ...tooltipProps }, { class: "bg-[#E2E2E9] text-black text-sm rounded-md px-1 py-1 border border-gray-500" }), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.raw[_unref(itemTitle)]), 1)
                  ]),
                  _: 2
                }, 1040)
              ]),
              _: 2
            }, 1032, ["text"]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value", "items", "item-title", "item-value", "loading", "class", "error", "error-messages"]))
}
}

})